import { can } from '@sportybot-web/auth/permissions/permissions';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/rules')({
  beforeLoad: ({ context: { user } }) => {
    if (!can(user, 'CAN_ACCESS_RULES')) {
      throw redirect({ to: '/' });
    }
  },
  component: Outlet,
});
